import { render, staticRenderFns } from "./QUnreadNotices.vue?vue&type=template&id=63a88534&"
import script from "./QUnreadNotices.vue?vue&type=script&lang=ts&"
export * from "./QUnreadNotices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports